import { GraphQLClient } from 'graphql-request';
import { GRAPHQL_API_URL } from './config';
import { getCompanyUid, getTokenFromCookies, getSsoForced } from './globals';

function getHeaders(): { [key: string]: string } {
  const token = getTokenFromCookies();
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...(getSsoForced() ? { 'sso-forced': 'true' } : {}),
    'company-uid': getCompanyUid(),
  };
}

export type OperationVariables = {
  [key: string]: any;
};

async function query<R extends {}, V extends OperationVariables>(
  queryString: string,
  variables: V
): Promise<R> {
  const graphQLClient = new GraphQLClient(GRAPHQL_API_URL, {
    headers: getHeaders(),
  });

  const data = await graphQLClient.request<R>(queryString, variables);
  return data;
}

export default query;
